const OptionStrengthAndMobility = 'Strength & Mobility'
const OptionLowIntensity = 'Low-Intensity Training'
const OptionModerateIntensity = 'Moderate-Intensity Training'

export const InitialOptions = [
  OptionStrengthAndMobility,
  OptionLowIntensity,
  OptionModerateIntensity,
]

export const Questions = [
  {
    id: 'balance',
    text: 'Balance problems and/or any recent fall?',
    type: 'boolean',
    transform: (options, value) => (value ? [OptionStrengthAndMobility] : options),
  },
  {
    id: 'beta-blockers',
    text: 'Are beta-blockers being used?',
    type: 'boolean',
    transform: (options, value) =>
      value ? options.filter((o) => o !== OptionModerateIntensity) : options,
  },
  {
    id: 'variceal-bleeding-tips',
    text: 'Prior TIPS?',
    type: 'boolean',
    transform: (options, value) => options,
  },
  {
    id: 'variceal-bleeding',
    text: 'Prior variceal bleeding?',
    type: 'boolean',
    transform: (options, value, all) => {
      if (all['variceal-bleeding-tips']) return options
      return value ? options.filter((o) => o !== OptionModerateIntensity) : options
    },
  },
  {
    id: 'refractory-ascites',
    text: 'Is there refractory ascites or recurrent hydrothorax?',
    type: 'boolean',
    transform: (options, value) => (value ? [OptionStrengthAndMobility] : options),
  },
  {
    id: 'encephalopathy',
    text: 'Is there encephalopathy or use of anti-ammonia drugs?',
    type: 'boolean',
    transform: (options, value) =>
      value ? options.filter((o) => o !== OptionModerateIntensity) : options,
  },
  {
    id: 'ascites-or-diuretics',
    text: 'Is there any ascites or use of diuretics?',
    type: 'boolean',
  },
  {
    id: 'hemoglobin',
    text: 'What is the hemoglobin?',
    type: 'number',
    min: 5,
    max: 25,
    transform: (options, value) => (Number(value) < 8 ? [OptionStrengthAndMobility] : options),
  },
  {
    id: 'bilirubin',
    text: 'What is the bilirubin?',
    type: 'number',
    min: 0.1,
    max: 40.0,
    step: 0.1,
  },
  {
    id: 'creatinine',
    text: 'What is the creatinine?',
    type: 'number',
    min: 0.1,
    max: 40.0,
    step: 0.1,
  },
  {
    id: 'inr',
    text: 'What is the INR?',
    type: 'number',
    min: 0.5,
    max: 20.0,
    step: 0.1,
  },
  {
    id: 'meld',
    type: 'calculated',
    calculation: ({ bilirubin, creatinine, inr }) => {
      return Math.round(
        9.57 * Math.log(Math.min(4, Math.max(1, creatinine))) +
          3.78 * Math.log(bilirubin) +
          11.2 * Math.log(inr) +
          6.43
      )
    },
    transform: (options, value) => {
      if (Number(value) > 30) {
        return [OptionStrengthAndMobility]
      }
      if (Number(value) >= 20 && Number(value) <= 30) {
        return options.filter((o) => o !== OptionModerateIntensity)
      }
      return options
    },
  },
  {
    id: 'sodium',
    text: 'What is the sodium?',
    type: 'number',
    min: 115,
    max: 150,
  },
  {
    id: 'meld-na',
    type: 'calculated',
    calculation: ({ meld, sodium }) => {
      // calculate MELD-na
      const bounded = Math.min(137, Math.max(125, sodium))
      const rounded = Math.round(meld + 1.32 * (137 - bounded) - 0.033 * meld * (137 - bounded))
      return Math.min(40, rounded)
    },
  },
  {
    id: 'albumin',
    text: 'What is the albumin?',
    type: 'number',
    min: 0,
    max: 5,
    step: 0.1,
  },
  {
    id: 'child-turcotte-pugh',
    type: 'calculated',
    calculation: (all) => {
      let points = 0

      if (all['refractory-ascites']) {
        points += 3
      } else if (all['ascites-or-diuretics']) {
        points += 2
      } else {
        points += 1
      }
      if (all['encephalopathy']) {
        points += 2
      } else {
        points += 1
      }
      if (all['bilirubin'] < 2) {
        points += 1
      } else if (all['bilirubin'] > 3) {
        points += 3
      } else {
        points += 2
      }
      if (all['inr'] < 1.7) {
        points += 1
      } else if (all['inr'] > 2.3) {
        points += 3
      } else {
        points += 2
      }
      if (all['albumin'] > 3.5) {
        points += 1
      } else if (all['albumin'] < 2.8) {
        points += 3
      } else {
        points += 2
      }
      return points
    },
    transform: (options, value) => {
      if (Number(value) >= 11 && Number(value) <= 14) {
        return [OptionStrengthAndMobility]
      }
      if (Number(value) >= 8 && Number(value) <= 10) {
        return options.filter((o) => o !== OptionModerateIntensity)
      }
      return options
    },
  },
  {
    id: 'liver-frailty-index',
    text: 'Are you providing the Liver Frailty Index Score?',
    type: 'liverFrailty',
  },
]
